module.exports = __webpack_public_path__ + "static/img/flogo.553a22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flogo.png
// module id = b+Sx
// module chunks = 34